export default "__VITE_ASSET__d17a526e__"